module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/19.c4f50ff9.png";